import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import MapView from "@/pages/MapView";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import AdegaDashboard from "@/pages/AdegaDashboard";
import Landing from "@/pages/Landing";
import { Terms, Privacy } from "@/pages/Legal";
import ReportDialog from "@/components/app/ReportDialog";

function CookieBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("encosta_cookies")) setVisible(true);
  }, []);
  const choose = (v) => { localStorage.setItem("encosta_cookies", v); setVisible(false); };
  if (!visible) return null;
  return (
    <div className="fixed bottom-[72px] inset-x-2 z-[1200] glass rounded-xl px-3 py-2 text-xs max-w-sm mx-auto flex items-center gap-2" data-testid="cookie-banner">
      <span className="flex-1">Usamos só cookies essenciais pra manter você conectado. Sem rastreadores.</span>
      <button onClick={()=>choose("accept")} className="h-8 px-3 bg-primary text-primary-foreground rounded-md font-semibold press text-xs" data-testid="cookie-accept">Ok</button>
      <button onClick={()=>choose("reject")} className="h-8 px-2 bg-muted rounded-md press text-xs" data-testid="cookie-reject">Essenciais</button>
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-muted-foreground">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Home() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-muted-foreground">Carregando...</div>;
  return user ? <MapView /> : <Landing />;
}

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/termos" element={<Terms />} />
      <Route path="/privacidade" element={<Privacy />} />
      <Route path="/" element={<Home />} />
      <Route path="/profile" element={<Protected><Profile /></Protected>} />
      <Route path="/adega" element={<Protected><AdegaDashboard /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Router />
        <CookieBanner />
        <ReportDialog />
        <Toaster theme="dark" position="top-center" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
